import React from "react";
import "../../assets/css/accept.css";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import Seller_sidebar from "./Seller-sidebar/Seller_sidebar";
import Seller_tabs_list from "./Seller-sidebar/Seller_tabs_list";
import { ad1 } from "../../constants";
import SellerHeader from "../../components/SellerHeader/SellerHeader";
import SellerFooter from "../../components/SellerFooter/SellerFooter";

const Seller_accept_refund = () => {
	return (
		<>
			{/* Header starts here */}
			<SellerHeader />
			{/* Header ends here */}
			<section className="dashboard">
				<div className="container">
					<div className="row">
						<div className="col-lg-4">
							<Seller_sidebar />
						</div>
						<div className="col-lg-8">
							<Seller_tabs_list />
							{/* Accept refund form starts here */}
							<div className="accept-refund-wrapper">
								<button className="close">
									<i className="fa fa-close"></i>
								</button>
								<div className="accept-form-wrapper">
									<div className="accept-head-wrapper">
										<h3>Accept Refund</h3>
										<div className="accept-date-wrapper">
											<h6>Refund Request Date</h6>
											<span className="date">10/11/22</span>
										</div>
									</div>
									<div className="accept-schedule-wrapper">
										<div className="schedule-head-wrapper">
											<h4>Schedule Voucher Code</h4>
										</div>
										<div className="schedule-form-wrapper pt-2">
											<form action="">
												<div className="form-group row">
													<div className="col-lg-6">
														<label htmlFor="">Start Voucher Date</label>
														<input type="date" className="form-control" />
													</div>
													<div className="col-lg-6">
														<label htmlFor="">End Voucher Date</label>
														<input type="date" className="form-control" />
													</div>
												</div>
												<div className="form-group row">
													<div className="col-lg-6">
														<label htmlFor="Discount Voucher ">
															Discount Voucher{" "}
														</label>
														<div className="generate-wrapper">
															<input
																type="password"
																className="form-control"
																value={"password"}
															/>
															<button className="btn">Generate Code</button>
														</div>
													</div>
													<div className="col-lg-6">
														<label htmlFor="">Discount Voucher</label>
														<input
															type="number"
															placeholder="60"
															className="form-control"
														/>
													</div>
												</div>
												<div className="form-group pt-3">
													<button className="btn form-control">
														Send Via Email
													</button>
												</div>
											</form>
										</div>
									</div>
								</div>
							</div>
							{/* Accept refund form ends here */}
						</div>
					</div>
				</div>
			</section>
			{/* Footer starts here */}
			<SellerFooter />
			{/* Footer ends here */}
		</>
	);
};

export default Seller_accept_refund;
